// extracted by mini-css-extract-plugin
export default {"primaryBlueButton":"QLltdC3kXJNv7u1_5QBRR"};